import type React from 'react'
import Skeleton from 'react-loading-skeleton'
import ApparelProductSkeleton from '@components/ApparelProductSkeleton/ApparelProductSkeleton'
import * as S from './Minisearch.styles'

export const ProductSearchResultsSkeleton: React.FC<{
  showCollections?: boolean
}> = ({ showCollections = false }) => {
  const itemCount = showCollections ? 4 : 8

  return (
    <S.SuggestionsContainer>
      <S.TitleContainer>
        <h2>
          <Skeleton width="120px" height="2rem" />
        </h2>
        <S.ViewAllLink>
          <Skeleton width="80px" height="1.6rem" />
        </S.ViewAllLink>
      </S.TitleContainer>
      <S.HorizontalList
        role="region"
        tabIndex={0}
        aria-label="Search results loading"
      >
        {Array.from({ length: itemCount }).map((_, index) => (
          <ApparelProductSkeleton showProductType key={index} layout="card" />
        ))}
      </S.HorizontalList>
    </S.SuggestionsContainer>
  )
}
